<template>
  <t-form labelWidth="90px">
    <t-form-item label="背景颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.bgColor" size="small" enableAlpha/>
    </t-form-item>
    <t-form-item label="标题">
      <t-input v-model="attribute.title" size="small" :maxcharacter="52"/>
    </t-form-item>
    <t-form-item label="文本颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.textColor" size="small"/>
    </t-form-item>
    <t-form-item label="文字大小">
      <t-input-number :min="12" :max="200" v-model="attribute.fontSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="圆角">
      <t-input-number :min="0" :max="100" v-model="attribute.radius" size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图标">
      <div @click="showGallery" style="width: 168px; height: 160px">
        <t-image style="width: 100%;height: 100%;background: none" :src="attribute.icon? fileUrl + attribute.icon:require('@/assets/logo.png')" fit="fill"/>
      </div>
    </t-form-item>
    <t-form-item label="图标大小">
      <t-input-number :min="10" :max="300" v-model="attribute.iconSize" size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图标左边距">
      <t-input-number :min="10" :max="600" v-model="attribute.iconBoxLeft" size="small" :decimal-places="0"/>
    </t-form-item>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
  </t-form>
</template>

<script>
import {fileUrl} from "/env";
import Gallery from "@/components/designer/gallery";

export default {
  name: "cpt-link-card-option",
  components: {Gallery},
  props: {attribute: Object},
  data(){
    return {
      fileUrl
    }
  },
  methods:{
    showGallery(){
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.icon = fileUrl
    }
  }
}
</script>

<style scoped>

</style>
